import { Column, Img, Row } from "@react-email/components";
import { stripPx } from "@circle-react-shared/Emails/VisualEmailBuilder/Utils/stripPx";
import { defaultStyles } from "../defaultStyles";

interface LogoSectionProps {
  communityName: string;
  iconUrl: string | null;
  logoUrl: string | null;
}

export const LogoSection = ({
  logoUrl,
  iconUrl,
  communityName,
}: LogoSectionProps) => {
  if (logoUrl) {
    return (
      <Row style={defaultStyles.content.logo}>
        <Column align="center">
          <Img
            style={{
              height: defaultStyles.content.logo.image.height,
              display: "inline-block",
              maxWidth: "100%",
              width: "auto",
            }}
            height={stripPx(defaultStyles.content.logo.image.height)}
            src={logoUrl}
            alt={communityName}
          />
        </Column>
      </Row>
    );
  }
  if (iconUrl) {
    return (
      <>
        <Row style={defaultStyles.content.logo}>
          <Column align="center">
            <Img
              style={{
                height: defaultStyles.content.logo.icon.height,
                width: defaultStyles.content.logo.icon.width,
              }}
              height={stripPx(defaultStyles.content.logo.icon.height)}
              width={stripPx(defaultStyles.content.logo.icon.width)}
              src={iconUrl}
            />
          </Column>
        </Row>
        <Row style={defaultStyles.content.logo}>
          <Column align="center">
            <span style={defaultStyles.content.logo.communityName}>
              {communityName}
            </span>
          </Column>
        </Row>
      </>
    );
  }
  return (
    <Row style={defaultStyles.content.logo}>
      <Column align="center">
        <span style={defaultStyles.content.logo.communityName}>
          {communityName}
        </span>
      </Column>
    </Row>
  );
};
